"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostMessageAdapter = void 0;
var Utility_1 = require("./Utility");
var PostMessageAdapter = /** @class */ (function () {
    function PostMessageAdapter() {
    }
    PostMessageAdapter.prototype.getConfiguration = function () {
        window.addEventListener('message', function (platformEvent) {
            if (platformEvent.data && platformEvent.data.name === 'NSoft.Product.SetConfiguration') {
                var event_1 = new CustomEvent('Configuration:SetConfiguration', {
                    detail: platformEvent.data.payload,
                });
                window.dispatchEvent(event_1);
            }
        });
    };
    PostMessageAdapter.prototype.parseEventPayload = function (payload) {
        var environment = (0, Utility_1.defaultToAny)(payload.environment, payload.env, undefined);
        var platformName = (0, Utility_1.defaultToAny)(payload.platformName, payload.platform, undefined);
        var platformDataCenter = (0, Utility_1.defaultToAny)(payload.platformDataCenter, payload.platformDc, undefined);
        var productName = (0, Utility_1.defaultToAny)(payload.productName, payload.product, undefined);
        var productId = (0, Utility_1.defaultToAny)(payload.productId, payload.cpvUuid, undefined);
        var productUuid = (0, Utility_1.defaultToAny)(payload.productUuid, undefined);
        var tenantId = (0, Utility_1.defaultToAny)(payload.tenantId, payload.tenant, payload.company, undefined);
        var locale = (0, Utility_1.defaultToAny)(payload.locale, payload.language, payload.lang, undefined);
        var applicationName = (0, Utility_1.defaultToAny)(payload.applicationName, payload.appName, payload.app, undefined);
        var user = (0, Utility_1.defaultToAny)(payload.user, undefined);
        var ui = (0, Utility_1.defaultToAny)(payload.ui, undefined);
        var betslip = (0, Utility_1.defaultToAny)(payload.betslip, undefined);
        var isIntegration = (0, Utility_1.defaultToAny)(payload.isIntegration, undefined);
        var betshopId = (0, Utility_1.defaultToAny)(payload.betshopId, undefined);
        var deviceId = (0, Utility_1.defaultToAny)(payload.deviceId, undefined);
        var channelId = (0, Utility_1.defaultToAny)(payload.channelId, undefined);
        var scrollButtons = (0, Utility_1.defaultToAny)(payload.scrollButtons, undefined);
        var moneyDenominations = (0, Utility_1.defaultToAny)(payload.moneyDenominations, undefined);
        return {
            environment: environment,
            platformName: platformName,
            platformDataCenter: platformDataCenter,
            productName: productName,
            productId: productId,
            productUuid: productUuid,
            tenantId: tenantId,
            locale: locale,
            applicationName: applicationName,
            user: user,
            ui: ui,
            betslip: betslip,
            isIntegration: isIntegration,
            betshopId: betshopId,
            deviceId: deviceId,
            channelId: channelId,
            scrollButtons: scrollButtons,
            moneyDenominations: moneyDenominations,
        };
    };
    return PostMessageAdapter;
}());
exports.PostMessageAdapter = PostMessageAdapter;
//# sourceMappingURL=PostMessageAdapter.js.map